import { AppName, Cohort, Color } from 'root-constants'
import { TAppName, TPartialMap } from 'root-types'

import { TOfferDetails, TUpsellConfig } from './types'

export const UPSELL_CONTEXT = {
  ayah: 'ayah',
  karma: 'karma',
  parenting: 'parenting',
  parentingV2: 'parenting_v2',
  default: '',
} as const

export const OFFERS_DETAIL_KARMA_IMAGES_CONFIG = [
  {
    image: 'upsell-karma-calm-toolkit-product',
    title: `upsell.details_karma.titleCalmToolkit`,
    description: `upsell.details_karma.descriptionCalmToolkit`,
    $bgColor: Color.GREEN_LIGHT,
  },
  {
    image: 'upsell-karma-skillful-life-product',
    title: `upsell.details_karma.titleSkillfulLife`,
    description: `upsell.details_karma.descriptionSkillfulLife`,
    $bgColor: Color.GOLD,
  },
]

export const OFFERS_DETAIL_AYAH_IMAGES_CONFIG = [
  {
    image: 'upsell-ayah-howto-product',
    title: `upsell.details_ayah.titleHowTo`,
    description: `upsell.details_ayah.descriptionHowTo`,
    $bgColor: Color.BEIGE_BASE,
  },
  {
    image: 'upsell-ayah-finding-product',
    title: `upsell.details_ayah.titleFinding`,
    description: `upsell.details_ayah.descriptionFinding`,
    $bgColor: Color.GREEN_LIGHT,
  },
] as const satisfies readonly TOfferDetails[]

export const OFFERS_DETAIL_PARENTING_IMAGES_CONFIG = [
  {
    image: 'upsell-ayah-parent-howto',
    title: `upsell.details_parenting.titleHowTo`,
    description: `upsell.details_parenting.descriptionHowTo`,
    $bgColor: Color.BEIGE_BASE,
  },
  {
    image: 'upsell-ayah-parent-finding',
    title: `upsell.details_parenting.titleFinding`,
    description: `upsell.details_parenting.descriptionFinding`,
    $bgColor: Color.GREEN_LIGHT,
  },
] as const satisfies readonly TOfferDetails[]

export const OFFERS_DETAIL_PARENTING_V2_CONFIG = [
  {
    image: 'upsell-parenting-raising-kids-image',
    title: `upsell.details_parenting_v2.titleHowTo`,
    description: `upsell.details_parenting_v2.descriptionHowTo`,
    $bgColor: Color.SAND_DARK,
  },
  {
    image: 'upsell-parenting-tranquil-home-image',
    title: `upsell.details_parenting_v2.titleFinding`,
    description: `upsell.details_parenting_v2.descriptionFinding`,
    $bgColor: Color.PINK_DARK,
  },
] as const satisfies readonly TOfferDetails[]

export const OFFERS_DETAILS_CONFIG = [
  {
    image: 'upsell-blessed-howto-product',
    title: `upsell.details.titleHowTo`,
    description: `upsell.details.descriptionHowTo`,
    $bgColor: Color.BEIGE_BASE,
  },
  {
    image: 'upsell-blessed-finding-product',
    title: `upsell.details.titleFinding`,
    description: `upsell.details.descriptionFinding`,
    $bgColor: Color.GREEN_LIGHT,
  },
] as const satisfies readonly TOfferDetails[]

export const AYAH_UPSELL_CONFIG = {
  titleKey: 'upsell.title',
  context: UPSELL_CONTEXT.ayah,
  offersDetails: OFFERS_DETAIL_AYAH_IMAGES_CONFIG,
  highlightsKey: 'upsell.highlights_ayah',
} as const satisfies TUpsellConfig

export const BLESSED_UPSELL_CONFIG = {
  titleKey: 'upsell.title',
  context: UPSELL_CONTEXT.default,
  offersDetails: OFFERS_DETAILS_CONFIG,
  highlightsKey: 'upsell.highlights',
} as const satisfies TUpsellConfig

export const KARMA_UPSELL_CONFIG = {
  titleKey: 'upsell.title_v2',
  context: UPSELL_CONTEXT.karma,
  offersDetails: OFFERS_DETAIL_KARMA_IMAGES_CONFIG,
  highlightsKey: 'upsell.highlights_karma',
} as const satisfies TUpsellConfig

export const UPSELL_CONFIG_BY_APP = {
  [AppName.blessedPath]: BLESSED_UPSELL_CONFIG,
  [AppName.ayahPath]: AYAH_UPSELL_CONFIG,
  [AppName.karmaPath]: KARMA_UPSELL_CONFIG,
} as const satisfies Record<TAppName, TUpsellConfig>

export const UPSELL_OVERRIDES_BY_COHORT = {
  [Cohort.AP_QURAN_326]: {
    titleKey: 'upsell.title_ayah_326',
  },
  [Cohort.AP_PARENTING_313_C]: {
    titleKey: 'upsell.title_parenting',
    context: UPSELL_CONTEXT.parenting,
    offersDetails: OFFERS_DETAIL_PARENTING_IMAGES_CONFIG,
    highlightsKey: 'upsell.highlights_parenting',
  },
} as const satisfies TPartialMap<Cohort, Partial<TUpsellConfig>>

export const PARENTING_UPSELL_V2_OVERRIDE = {
  context: UPSELL_CONTEXT.parentingV2,
  offersDetails: OFFERS_DETAIL_PARENTING_V2_CONFIG,
  highlightsKey: 'upsell.highlights_parenting_v2',
} as const satisfies Partial<TUpsellConfig>
